//        export const BASE_URL = 'http://localhost:8080/';

//http://a86f4fc2bf8b347d191ece7f35409017-724927569.eu-central-1.elb.amazonaws.com/

//http://a86f4fc2bf8b347d191ece7f35409017-724927569.eu-central-1.elb.amazonaws.com

//https://d20kwg47th11r1.cloudfront.net

          export const BASE_URL = "https://d20kwg47th11r1.cloudfront.net/";
//export const BASE_URL = "http://6cbd-102-89-45-109.ngrok.io/";
